import { useAppContext } from 'contexts/app-context/hooks'
import { isEmpty } from 'lodash'
import { useLocation, useNavigate } from 'react-router-dom'
import { Routes } from 'common/constants'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'

export function useUnavailableService() {
  const { privacyCenterContent, isAppError, isAppActive, isAppLoading, userSelectedEntity } =
    useAppContext()

  const content = privacyCenterContent?.components?.unavailableService?.content

  const navigate = useNavigate()

  const location = useLocation()

  const closeHandler = () => navigate(location.state?.goTo || -1)

  const isError = isEmpty(content) || isAppError || !isAppActive

  useScreenFinishLoadTac({
    name: 'UnavailableService',
    entity: userSelectedEntity,
    action: 'UnavailableService',
    screen: Routes.UNAVAILABLE_SERVICE,
    shouldSend: true,
    logLabel: 'send unavailable service tac',
  })

  return {
    ...content,
    isError,
    isLoading: isAppLoading,
    goTo: location.state?.goTo || null,
    onClose: closeHandler,
  }
}
